import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Modal } from "react-bootstrap";
import {
  animationValues,
  transitionValues,
} from "../../../utils/pageTransitions";
import InputField from "../../reusables/input";
import Dropdown from "../../reusables/dropdown";
import { connect } from "react-redux";
import { fetch_transactions } from "../../../redux/actions/adminActions";
import Spinner from "../../reusables/spinner";

function FailedTransactions({ getTransactions, accessToken, transactions }) {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    getTransactions(accessToken, "failed", () => setLoading(false));
  }, []);

  const [optionsActive, setOptions] = useState(false);

  const [detailsModal, setModal] = useState(false);

  const [selected, setSelect] = useState(null);

  const handleModal = (item) => {
    setSelect(item);
    setModal(true);
  };

  const [filteredTransactions, setTrans] = useState([]);

  const [search, setSearch] = useState("");

  const [hasFilter, setFilter] = useState(false);

  const searchHandler = (e) => {
    if (search !== "") {
      const searchResults = transactions.filter((i) => i.ref_number == search);
      setTrans(searchResults);
      setFilter(true);
    } else {
      setFilter(false);
    }
  };

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="pt-3">
        <div className="spaceBetween mobileBlock">
          <div className="searchHolder">
            <InputField
              placeholder="Search by Ref Number"
              name={search}
              iconClick={searchHandler}
              onChange={(e) => setSearch(e.target.value)}
              icon
              iconClass="ri-search-line"
            />
          </div>

          <div className="alignOnly pt-2">
            <Dropdown value="All dates" className="mx-1" />
            <Dropdown value="Status" className="mx-1" />
          </div>
        </div>

        <div className="sectionHeight--mid scrollable--mobile pt-4">
          {!loading ? (
            <table className="table table__custom">
              <thead className="sectionText--small textIsGray table__head pb-2">
                <tr className="">
                  <th className="">Ref Number</th>
                  <th className="vAlign">Date</th>
                  <th className="vAlign">Amount</th>
                  <th className="vAlign">Customer</th>
                  <th className="vAlign">Channel</th>
                  <th className="vAlign">Status</th>
                  <th className="vAlign">Action</th>
                </tr>
              </thead>
              <tbody className="">
                {hasFilter
                  ? filteredTransactions?.map((item) => (
                      <tr className="hasRadius">
                        <td className="alignOnly pt-3">
                          <input
                            type="checkbox"
                            className="isClickable"
                            name=""
                            id=""
                          />

                          <p className="mb-0  sectionText mx-2">
                            #{item.ref_number}
                          </p>
                        </td>

                        <td className="pt-3 vAlign">
                          <p className="mb-0  sectionText">{item.date}</p>
                        </td>

                        <td className="pt-3 vAlign">
                          <p className="mb-0  sectionText">₦{item.amount}</p>
                        </td>

                        <td className="vAlign pt-3">
                          <p className="mb-0 sectionText textIsGreen">
                            {item.user?.first_name}
                          </p>
                        </td>

                        <td className="vAlign pt-3 address">
                          <p className="mb-0 sectionText">
                            {item.payment_channel}
                          </p>
                        </td>

                        <td className="">
                          <p
                            className={`mb-0 sectionText tag ${
                              item.status === "successful" && "done"
                            } ${item.status === "failed" && "red"} ${
                              item.status === "pending" && "pending"
                            }`}
                          >
                            {item.status}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          <i
                            class="ri-more-line isClickable"
                            onClick={
                              optionsActive === item.ref_number
                                ? () => setOptions(null)
                                : () => setOptions(item.ref_number)
                            }
                          ></i>

                          {optionsActive === item.ref_number && (
                            <div className="options">
                              <div className="caret"></div>
                              <div
                                className="p-2 textIsBold lAlign sectionText--small"
                                onClick={() => handleModal(item)}
                              >
                                <div className="">View</div>
                              </div>
                            </div>
                          )}
                        </td>
                      </tr>
                    ))
                  : transactions?.map((item) => (
                      <tr className="hasRadius">
                        <td className="alignOnly pt-3">
                          <input
                            type="checkbox"
                            className="isClickable"
                            name=""
                            id=""
                          />

                          <p className="mb-0  sectionText mx-2">
                            #{item.ref_number}
                          </p>
                        </td>

                        <td className="pt-3 vAlign">
                          <p className="mb-0  sectionText">{item.date}</p>
                        </td>

                        <td className="pt-3 vAlign">
                          <p className="mb-0  sectionText">₦{item.amount}</p>
                        </td>

                        <td className="vAlign pt-3">
                          <p className="mb-0 sectionText textIsGreen">
                            {item.user?.first_name}
                          </p>
                        </td>

                        <td className="vAlign pt-3 address">
                          <p className="mb-0 sectionText">
                            {item.payment_channel}
                          </p>
                        </td>

                        <td className="">
                          <p
                            className={`mb-0 sectionText tag ${
                              item.status === "successful" && "done"
                            } ${item.status === "failed" && "red"} ${
                              item.status === "pending" && "pending"
                            }`}
                          >
                            {item.status}
                          </p>
                        </td>

                        <td className="vAlign pt-3">
                          <i
                            class="ri-more-line isClickable"
                            onClick={
                              optionsActive === item.ref_number
                                ? () => setOptions(null)
                                : () => setOptions(item.ref_number)
                            }
                          ></i>

                          {optionsActive === item.ref_number && (
                            <div className="options">
                              <div className="caret"></div>
                              <div
                                className="p-2 textIsBold lAlign sectionText--small"
                                onClick={() => handleModal(item)}
                              >
                                <div className="">View</div>
                              </div>
                            </div>
                          )}
                        </td>
                      </tr>
                    ))}
              </tbody>
            </table>
          ) : (
            <Spinner big />
          )}
        </div>
      </div>

      <Modal show={detailsModal} onHide={() => setModal(false)} centered>
        <div className="sectionHeight--mid alignOnly p-3">
          <div className="w-100">
            <h2 className="sectionText--mid">Transaction Details</h2>

            <div className="pt-2">
              <div className="hasBorder hasRadius spaceBetween alignOnly px-3 py-2">
                <div className="">
                  <p className="mb-1 sectionText">Amount</p>
                  <p className="sectionText--mid mb-0">₦ {selected?.amount}</p>
                </div>

                <div className="">
                  <div
                    className={`tag sectionText--small ${
                      selected?.status === "successful" && "done"
                    } ${selected?.status === "failed" && "red"} ${
                      selected?.status === "pending" && "pending"
                    }`}
                  >
                    {selected?.status}
                  </div>
                </div>
              </div>

              <div className="mt-3 hasBorder hasRadius">
                <div className="hasBorder--bottom alignOnly p-2">
                  <h2 className="sectionText--mid mb-0">Payment Information</h2>
                </div>

                <div className="pt-2 pb-2 container">
                  <div className="row">
                    <div className="col-lg-7 sectionText">
                      <div className="spaceBetween">
                        <p className="mb-0">Reference</p>
                        <p className="mb-0">{selected?.ref_number}</p>
                      </div>
                      <div className="spaceBetween mt-2 mb-2">
                        <p className="mb-0">Customer</p>
                        <p className="mb-0">{selected?.user?.first_name}</p>
                      </div>
                      <div className="spaceBetween mt-2 mb-2">
                        <p className="mb-0">Channel</p>
                        <p className="mb-0">{selected?.payment_channel}</p>
                      </div>
                      <div className="spaceBetween mt-2 mb-2">
                        <p className="mb-0">Date</p>
                        <p className="mb-0">{selected?.date}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </motion.div>
  );
}

const mapStateToProps = (state) => ({
  accessToken: state.admin.token,
  transactions: state.admin.transactions,
});

const mapDispatchToProps = (dispatch) => ({
  getTransactions: (token, status, success) =>
    dispatch(fetch_transactions(token, status, success)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FailedTransactions);
